module.exports = __webpack_public_path__ + "img/craftBannerElectricianMobile.4b82a87.webp";